import {createEvent, type Emitter, type Listener} from "react-event-hook";

export interface TeacherAccessPermissionsUpdatedPayload {
    canPreviewLoggedOutTools?: boolean;
}

interface Event {
    useTeacherAccessPermissionsUpdatedListener: Listener<TeacherAccessPermissionsUpdatedPayload>;
    emitTeacherAccessPermissionsUpdated: Emitter<TeacherAccessPermissionsUpdatedPayload>;
}

export const {
    useTeacherAccessPermissionsUpdatedListener,
    emitTeacherAccessPermissionsUpdated,
} = createEvent("teacher-access-permissions-updated")() satisfies Event;
